export enum CompanyQueryKeys {
  GET_COMPANY_INFO = 'GET_COMPANY_INFO',
  GET_COMPANY_LIST = 'GET_COMPANY_LIST',
}
